import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { optionCarousel } from 'src/app/utility/carousel.config';

@Component({
  selector: 'app-container-sample-card',
  templateUrl: './container-sample-card.component.html',
  styleUrls: ['./container-sample-card.component.scss']
})
export class ContainerSampleCardComponent implements OnInit {

  @Input() block: any;
  public classColumn: string = '';
  private itemsNumber: number = 0;
  public customOptionsOwl: OwlOptions = {} as OwlOptions;

  constructor() { }

  ngOnInit(): void {
    this.customOptionsOwl = optionCarousel(this.block.bundle);
    if (this.block.bundle === 'blocco_card') {
      this.setColumnItemCarousel(this.block.items.length);
      this.customOptionsOwl = {
        ...this.customOptionsOwl,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          900: {
            items: 3
          },
          1200: {
            items: this.itemsNumber
          }
        }
      }
    } else {
      this.setColumnItem(this.block.items.length);
    }
  }

  setColumnItem(numberItems: number) {
    switch (this.block.colonne_occupate) {
      case '2':
        if (numberItems === 1) {
          this.classColumn = 'col-12';
        } else {
          this.classColumn = 'col-12 col-sm-6';
        }
        break;
      case '3':
        if (numberItems === 1) {
          this.classColumn = 'col-12';
        }
        if (numberItems === 2) {
          this.classColumn = 'col-12 col-sm-6';
        }
        if (numberItems > 2) {
          this.classColumn = 'col-12 col-sm-6 col-md-4';
        }
        break;
      case '4':
        if (numberItems === 1) {
          this.classColumn = 'col-12';
        }
        if (numberItems === 2) {
          this.classColumn = 'col-12 col-sm-6';
        }
        if (numberItems === 3) {
          this.classColumn = 'col-12 col-sm-6 col-md-4';
        }
        if (numberItems > 3) {
          this.classColumn = 'col-12 col-sm-6 col-md-4 col-lg-3';
        }
        break;
      default:
        this.classColumn = 'col-12';
        break;
    }
  }

  setColumnItemCarousel(numberItems: number) {
    switch (this.block.colonne_occupate) {
      case '2':
        if (numberItems === 1) {
          this.itemsNumber = 1;
        } else {
          this.itemsNumber = 2;
        }
        break;
      case '3':
        if (numberItems === 1) {
          this.itemsNumber = 1;
        }
        if (numberItems === 2) {
          this.itemsNumber = 2;
        }
        if (numberItems > 2) {
          this.itemsNumber = 3;
        }
        break;
      case '4':
        if (numberItems === 1) {
          this.itemsNumber = 1;
        }
        if (numberItems === 2) {
          this.itemsNumber = 2;
        }
        if (numberItems === 3) {
          this.itemsNumber = 3;
        }
        if (numberItems > 3) {
          this.itemsNumber = 4;
        }
        break;
      default:
        this.itemsNumber = 1;
        break;
    }
  }

}